import baseApi from "./baseApi"

export default  {
    /**
     * Fetch Plant Data from Server that matches token.
     * @return {Object} -- Plant Data
     */
    async getAllPlants() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/plants");
        return result.data;
    },
    /**
     * Fetch Plant Polygon Geo Location Data from Server that matches token.
     * @return {Object} -- Plant GEO Data
     */
    async getPlantPolygonGeoData(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/plants/PolygonGeoJson/" + plantID);
        return result.data;
    },
    /**
     * Fetch Plant Point Geo Location Data from Server that matches token.
     * @return {Object} -- Plant GEO Data
     */
    async getPlantPointGeoData(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/plants/PointGeoJson/" + plantID);
        return result.data;
    },
    /**
     * Fetch Plant Summary Data from Server that matches token.
     * @return {Object} -- Plant GEO Data
     */
    async getPlantSummary(date) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/plants/summary?date=" + date);
        return result.data;
    }
}